const SERVER_URL = 'https://dashboard.xn--diegebudereiniger-vqb.de/';
// const SERVER_URL = 'http://clients/reinigung/';
const API_PATH = 'fw/dgr/';
const API_VERSION = 'v1/';
const API_URL = SERVER_URL + API_PATH + API_VERSION;
export const INIT_PATH = API_URL + 'init/';
export const POSTS_PATH = API_URL + 'content/';
export const CONTACT_PATH = API_URL + 'contact/';
